export const SHOPPING_CART_ADD_PRODUCT_REQUEST = 'SHOPPING_CART_ADD_PRODUCT_REQUEST';
export const SHOPPING_CART_ADD_PRODUCT_SUCCESS = 'SHOPPING_CART_ADD_PRODUCT_SUCCESS';
export const SHOPPING_CART_ADD_PRODUCT_FAILURE = 'SHOPPING_CART_ADD_PRODUCT_FAILURE';
export const SHOPPING_CART_ADD_PRODUCT_CLEAR = 'SHOPPING_CART_ADD_PRODUCT_CLEAR';
